import * as React from "react"
import { RouteComponentProps, navigate } from "@gatsbyjs/reach-router"
import { BuildLogsList, BuildLogItem } from "gatsby-interface" // [sic]
import { useStructuredLogsForMerlinSourceEventQuery } from "./queries.generated"
import { Loading } from "gatsby-ui/src/components"
import { ErrorAlert } from "../shared/error-alert"
import { useMerlinSourceEventByIdQuery } from "../source-event/queries.generated"
import { isSystemVendor } from "../../utils/is-system-vendor"

interface SourceEventStructuredLogsProps extends RouteComponentProps {
  organizationId: string
  siteId: string
  sourceEventId: string
}

export function SourceEventStructuredLogs({
  siteId,
  sourceEventId,
  location,
}: SourceEventStructuredLogsProps) {
  const event = useMerlinSourceEventByIdQuery({
    variables: {
      sourceEventId,
    },
  })

  const isSystemEvent = isSystemVendor(
    event.data?.merlinSourceEventById?.cmsVendor
  )

  const { data, loading, error, subscribeToMore } =
    useStructuredLogsForMerlinSourceEventQuery({
      variables: {
        sourceEventId,
        offset: 0,
      },
      skip: isSystemEvent,
    })

  if (isSystemEvent) {
    const path = location?.pathname
    const redirectLink = `${path}${path?.endsWith(`/`) ? `raw` : `/raw`}`

    navigate(redirectLink)
  }

  return (
    <>
      {loading && <Loading message="Loading data layer activities..." />}
      {error && <ErrorAlert>{error.message}</ErrorAlert>}
      {data && (
        <>
          <BuildLogsList
            logItems={data.structuredLogsForMerlinSourceEvent as BuildLogItem[]}
            aria-label="Source Event Logs"
          />
        </>
      )}
    </>
  )
}
